import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  getTrainingSessionService,
  getTrainingSessionStatusService,
  getTrainingSessionsService,
} from '../services/trainingSessionService';

// Create async thunks
export const getAllTrainingSessions = createAsyncThunk(
  'trainingSessions/getAllTrainingSessions',
  async ({ reset } = {}) => {
      const { data } = await getTrainingSessionsService();
      return { trainingSessions: data, reset };
  }
);

export const queryTrainingSession = createAsyncThunk(
  'trainingSessions/queryTrainingSession',
  async (sessionId) => {
      const { data } = await getTrainingSessionService(sessionId);
      return { session: data, id: sessionId };
  }
);

export const getTrainingSessionStatus = createAsyncThunk(
  'trainingSessions/getTrainingSessionStatus',
  async (sessionId) => {
    const { data } = await getTrainingSessionStatusService(sessionId);
    return { status: data, id: sessionId };
  }
);

// Create slice
const trainingSessionsSlice = createSlice({
  name: 'trainingSessions',
  initialState: {},
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllTrainingSessions.pending, (state) => {
        console.log('Fetching all training sessions...');
      })
      .addCase(getAllTrainingSessions.fulfilled, (state, action) => {
        if (action.payload.reset) {
          return { ...action.payload.trainingSessions };
        }
        return { ...state, ...action.payload.trainingSessions };
      })
      .addCase(getAllTrainingSessions.rejected, (action) => {
        console.error('Failed to fetch training sessions:', action.error);
      })
      .addCase(queryTrainingSession.pending, (state) => {
        console.log('Querying training session...');
      })
      .addCase(queryTrainingSession.fulfilled, (state, action) => {
        const { session, id } = action.payload;
        state[id] = {
          ...session[id],
          status: state[id]?.status ? state[id].status : {},
        };
      })
      .addCase(queryTrainingSession.rejected, (action) => {
        console.error('Failed to query training session:', action.error);
      })
      .addCase(getTrainingSessionStatus.pending, (state) => {
        console.log('Fetching training session status...');
      })
      .addCase(getTrainingSessionStatus.fulfilled, (state, action) => {
        const { status, id } = action.payload;
        if (state[id]) {
          state[id].status = status;
        }
      })
      .addCase(getTrainingSessionStatus.rejected, (action) => {
        console.error('Failed to fetch training session status:', action.error);
      });
  },
});

export default trainingSessionsSlice.reducer;

// Selectors
export const selectTrainingSession = (state, id) => {
  return state.trainingSessions[id];
};